










// import React, { useState } from "react";
// import axios from "axios";

// const Login = () => {
//   const [identifier, setIdentifier] = useState(""); // Email or mobile
//   const [password, setPassword] = useState("");
//   const [newPassword, setNewPassword] = useState(""); // For password update
//   const [isReset, setIsReset] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [isPasswordUpdate, setIsPasswordUpdate] = useState(false); // Manage password update flow
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     if (!identifier || (!isReset && !password)) {
//       setError("Please fill in all required fields.");
//       return;
//     }

//     setLoading(true);

//     try {
//       if (isReset) {
//         if (!otpSent) {
//           // Step 1: Send OTP
//           const response = await axios.post("/api/resetpassword", { identifier });
//           alert(response.data.message);
//           setOtpSent(true);
//         } else if (otpSent && !isPasswordUpdate) {
//           // Step 2: Verify OTP
//           if (!otp) {
//             setError("Please enter the OTP sent to your email.");
//             setLoading(false);
//             return;
//           }
//           const response = await axios.post("/api/verify-otp", { identifier, otp });
//           alert(response.data.message);
//           setIsPasswordUpdate(true); // Redirect to password update step
//         } else if (isPasswordUpdate) {
//           // Step 3: Update Password
//           if (!newPassword) {
//             setError("Please enter a new password.");
//             setLoading(false);
//             return;
//           }
//           const response = await axios.post("/api/update-password", {
//             identifier,
//             newPassword,
//           });
//           alert(response.data.message); // Password updated successfully
//           setIsReset(false);
//           setOtpSent(false);
//           setOtp("");
//           setIsPasswordUpdate(false);
//           setNewPassword("");
//         }
//       } else {
//         // Normal Login
//         const response = await axios.post("/api/login", { identifier, password });
//         alert(response.data.message);
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || "Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="tf-page-title style-2">
//         <div className="container-full">
//           <div className="heading text-center">
//             {isReset ? (isPasswordUpdate ? "Update Password" : "Reset Password") : "Log in"}
//           </div>
//         </div>
//       </div>
//       <section className="flat-spacing-10">
//         <div className="container">
//           <div className="tf-grid-layout lg-col-2 tf-login-wrap">
//             <div className="tf-login-form">
//               <form className="" onSubmit={handleSubmit}>
//                 {!isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_15">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="text"
//                       value={identifier}
//                       onChange={(e) => setIdentifier(e.target.value)}
//                       placeholder={isReset ? "Enter your email" : "Enter email or mobile"}
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">
//                       {isReset ? "Email *" : "Email or Mobile *"}
//                     </label>
//                   </div>
//                 )}

//                 {!isReset && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       placeholder="Enter your password"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">Password *</label>
//                   </div>
//                 )}

//                 {isReset && otpSent && !isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                       placeholder="Enter OTP"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">OTP *</label>
//                   </div>
//                 )}

//                 {isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="password"
//                       value={newPassword}
//                       onChange={(e) => setNewPassword(e.target.value)}
//                       placeholder="Enter new password"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">New Password *</label>
//                   </div>
//                 )}

//                 {error && <p className="error-text">{error}</p>}

//                 <div className="mb_20">
//                   {!isPasswordUpdate && (
//                     <a
//                       onClick={() => {
//                         setIsReset(!isReset);
//                         setOtpSent(false);
//                         setOtp("");
//                       }}
//                       className="tf-btn btn-line"
//                     >
//                       {isReset ? "Back to Login" : "Forgot your password?"}
//                     </a>
//                   )}
//                 </div>

//                 <div className="">
//                   <button
//                     type="submit"
//                     className="tf-btn w-100 radius-3 btn-fill"
//                     disabled={loading}
//                   >
//                     {loading
//                       ? "Loading..."
//                       : isReset
//                       ? otpSent
//                         ? isPasswordUpdate
//                           ? "Update Password"
//                           : "Verify OTP"
//                         : "Send OTP"
//                       : "Log in"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//             <div className="tf-login-content">
//               <h5 className="mb_36">I'm new here</h5>
//               <p className="mb_20">
//                 Sign up for early Sale access plus tailored new arrivals, trends, and promotions.
//               </p>
//               <a href="/register" className="tf-btn btn-line">
//                 Register<i className="icon icon-arrow1-top-left"></i>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Login;

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//   const [identifier, setIdentifier] = useState(""); // Email or mobile
//   const [password, setPassword] = useState("");
//   const [newPassword, setNewPassword] = useState(""); // For password update
//   const [isReset, setIsReset] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [isPasswordUpdate, setIsPasswordUpdate] = useState(false); // Manage password update flow
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const navigate = useNavigate();

//   const decodeJWT = (token) => {
//     try {
//       const base64Url = token.split('.')[1];
//       const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//       const jsonPayload = decodeURIComponent(
//         atob(base64)
//           .split('')
//           .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//           .join('')
//       );
//       console.log("decoded",jsonPayload)
//       return JSON.parse(jsonPayload);

//     } catch (error) {
//       console.error('Error decoding token:', error);
//       // return null;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     if (!identifier || (!isReset && !password)) {
//       setError("Please fill in all required fields.");
//       return;
//     }

//     setLoading(true);

//     try {
//       if (isReset) {
//         if (!otpSent) {
//           // Step 1: Send OTP
//           const response = await axios.post("/api/resetpassword", { identifier });
//           alert(response.data.message);
//           setOtpSent(true);
//         } else if (otpSent && !isPasswordUpdate) {
//           // Step 2: Verify OTP
//           if (!otp) {
//             setError("Please enter the OTP sent to your email.");
//             setLoading(false);
//             return;
//           }
//           const response = await axios.post("/api/verify-otp", { identifier, otp });
//           alert(response.data.message);
//           setIsPasswordUpdate(true); // Redirect to password update step
//         } else if (isPasswordUpdate) {
//           // Step 3: Update Password
//           if (!newPassword) {
//             setError("Please enter a new password.");
//             setLoading(false);
//             return;
//           }
//           const response = await axios.post("/api/update-password", {
//             identifier,
//             newPassword,
//           });
//           alert(response.data.message); // Password updated successfully
//           setIsReset(false);
//           setOtpSent(false);
//           setOtp("");
//           setIsPasswordUpdate(false);
//           setNewPassword("");
//         }
//       } else {
//         // Normal Login
//         const response = await axios.post("/api/login", { identifier, password }


//         );
//         alert(response.data.message);
//         console.log(response.data.token)

//         const { token  } = response.data;
//         console.log("token",token)
//         navigate("/");


//       const decodedToken = decodeJWT(token);
//       console.log('Decoded Token:', decodedToken);
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || "Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="tf-page-title style-2">
//         <div className="container-full">
//           <div className="heading text-center">
//             {isReset ? (isPasswordUpdate ? "Update Password" : "Reset Password") : "Log in"}
//           </div>
//         </div>
//       </div>
//       <section className="flat-spacing-10">
//         <div className="container">
//           <div className="tf-grid-layout lg-col-2 tf-login-wrap">
//             <div className="tf-login-form">
//               <form className="" onSubmit={handleSubmit}>
//                 {!isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_15">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="text"
//                       value={identifier}
//                       onChange={(e) => setIdentifier(e.target.value)}
//                       placeholder={isReset ? "Enter your email" : "Enter email or mobile"}
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">
//                       {isReset ? "Email *" : "Email or Mobile *"}
//                     </label>
//                   </div>
//                 )}

//                 {!isReset && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       placeholder="Enter your password"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">Password *</label>
//                   </div>
//                 )}

//                 {isReset && otpSent && !isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                       placeholder="Enter OTP"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">OTP *</label>
//                   </div>
//                 )}

//                 {isPasswordUpdate && (
//                   <div className="tf-field style-1 mb_30">
//                     <input
//                       className="tf-field-input tf-input"
//                       type="password"
//                       value={newPassword}
//                       onChange={(e) => setNewPassword(e.target.value)}
//                       placeholder="Enter new password"
//                     />
//                     <label className="tf-field-label fw-4 text_black-2">New Password *</label>
//                   </div>
//                 )}

//                 {error && <p className="error-text">{error}</p>}

//                 <div className="mb_20">
//                   {!isPasswordUpdate && (
//                     <a
//                       onClick={() => {
//                         setIsReset(!isReset);
//                         setOtpSent(false);
//                         setOtp("");
//                       }}
//                       className="tf-btn btn-line"
//                     >
//                       {isReset ? "Back to Login" : "Forgot your password?"}
//                     </a>
//                   )}
//                 </div>

//                 <div className="">
//                   <button
//                     type="submit"
//                     className="tf-btn w-100 radius-3 btn-fill"
//                     disabled={loading}
//                   >
//                     {loading
//                       ? "Loading..."
//                       : isReset
//                       ? otpSent
//                         ? isPasswordUpdate
//                           ? "Update Password"
//                           : "Verify OTP"
//                         : "Send OTP"
//                       : "Log in"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//             <div className="tf-login-content">
//               <h5 className="mb_36">I'm new here</h5>
//               <p className="mb_20">
//                 Sign up for early Sale access plus tailored new arrivals, trends, and promotions.
//               </p>
//               <a href="/register" className="tf-btn btn-line">
//                 Register<i className="icon icon-arrow1-top-left"></i>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Login;


// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import jwtDecode from "jwt-decode";

// const Login = () => {
//   const [loginMode, setLoginMode] = useState("password"); // "password" or "otp"
//   const [identifier, setIdentifier] = useState(""); // Email or phone number
//   const [password, setPassword] = useState("");
//   const [otp, setOtp] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const navigate = useNavigate();
//   const location = useLocation();

//   // This will store the intended route or default to '/'
//   const redirectPath = location.state?.from || "/";
//   const HARD_CODED_PHONE = "9876543210"; // Hardcoded phone number
//   const HARD_CODED_OTP = "123456"; // Hardcoded OTP

//   const decodeJWT = (token) => {
//     try {
//       const base64Url = token.split('.')[1];
//       const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//       const jsonPayload = decodeURIComponent(
//         atob(base64)
//           .split('')
//           .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//           .join('')
//       );
//       return JSON.parse(jsonPayload);
//     } catch (error) {
//       console.error('Error decoding token:', error);
//       return null;
//     }
//   };

//   const handleLoginSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setLoading(true);

//     try {
//       if (loginMode === "password") {
//         // Password-based login
//         const response = await axios.post("/api/login", {
//           identifier,
//           password,
//         });
//         alert(response.data.message);

//         const { token } = response.data; // Get the token from the response
//         localStorage.setItem("token", token);

//         // Decode the token to extract the phone number
//         const decodedToken = decodeJWT(token);
//         if (decodedToken && decodedToken.phoneNumber) {
//           const phoneNumber = decodedToken.phoneNumber;
//           localStorage.setItem("phoneNumber", phoneNumber);
//           console.log("phoneNumber:", phoneNumber);
//         } else {
//           console.error("Failed to extract phoneNumber from token.");
//         }

//         navigate(redirectPath); // Navigate to the intended page
//       } else if (loginMode === "otp") {
//         // OTP-based login
//         if (!otpSent) {
//           // Send OTP
//           const response = await axios.post("/api/send-otp", {
//             phoneNumber: identifier,
//           });
//           alert(response.data.message); // Notify user that OTP was sent
//           setOtpSent(true); // Proceed to OTP input step
//         } else {
//           // Verify OTP
//           const response = await axios.post("/api/verify-otp-login", {
//             phoneNumber: identifier,
//             otp,
//           });

//           const { token } = response.data; // Get the token from the response
//           localStorage.setItem("token", token);

//           // Decode the token to extract the phone number
//           const decodedToken = decodeJWT(token);
//           if (decodedToken && decodedToken.phoneNumber) {
//             const phoneNumber = decodedToken.phoneNumber;
//             localStorage.setItem("phoneNumber", phoneNumber);
//             console.log("phoneNumber:", phoneNumber);
//           } else {
//             console.error("Failed to extract phoneNumber from token.");
//           }

//           alert(response.data.message); // Notify user of success
//           navigate(location.state?.from || "/");// Navigate to the intended page
//         }
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || "Something went wrong.");
//     } finally {
//       setLoading(false); // End the loading state
//     }
//   };

//   const handleLogout = () => {
//     // Clear token and phone number from localStorage
//     localStorage.removeItem("token");
//     localStorage.removeItem("phoneNumber");

//     // Optionally, you can redirect to login page after logout
//     alert("You have logged out successfully.");
//     navigate("/login");
//   };

//   // Check if the user is logged in by checking localStorage
//   const isLoggedIn = localStorage.getItem("token");

//   return (
//     <div>
//       {isLoggedIn ? (
//         <div>
//           <h2>You are already logged in.</h2>
//           <button onClick={handleLogout}>Logout</button>
//         </div>
//       ) : (
//         <div>
//           <h2>{loginMode === "password" ? "Password Login" : "OTP Login"}</h2>
//           <form onSubmit={handleLoginSubmit}>
//             <div>
//               <input
//                 type="text"
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value)}
//                 placeholder={loginMode === "password" ? "Enter email or mobile" : "Enter mobile number"}
//                 required
//               />
//             </div>

//             {loginMode === "password" ? (
//               <div>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   required
//                 />
//               </div>
//             ) : (
//               otpSent && (
//                 <div>
//                   <input
//                     type="text"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     placeholder="Enter OTP"
//                     required
//                   />
//                 </div>
//               )
//             )}

//             {error && <p className="{ color: "red" }}>{error}</p>}

//             <button type="submit" disabled={loading}>
//               {loading
//                 ? "Loading..."
//                 : loginMode === "password"
//                 ? "Login"
//                 : otpSent
//                 ? "Verify OTP"
//                 : "Send OTP"}
//             </button>
//           </form>

//           <button onClick={() => setLoginMode(loginMode === "password" ? "otp" : "password")}>
//             {loginMode === "password" ? "Login with OTP" : "Login with Password"}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Login;


////original and actaull working code
// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import jwtDecode from "jwt-decode";
// import { useCart } from "../../pages/CartContext/CartProvider"; // Import the custom hook

// const Login = () => {
//     const [loginMode, setLoginMode] = useState("password");
//     const [identifier, setIdentifier] = useState("");
//     const [password, setPassword] = useState("");
//     const [otp, setOtp] = useState("");
//     const [otpSent, setOtpSent] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const { cartItems } = useCart(); // Access cart data from context
//     const navigate = useNavigate();
//     const location = useLocation();

//     const decodeJWT = (token) => {
//         try {
//             const base64Url = token.split('.')[1];
//             const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//             const jsonPayload = decodeURIComponent(
//                 atob(base64)
//                     .split('') 
//                     .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//                     .join('')
//             );
//             return JSON.parse(jsonPayload);
//         } catch (error) {
//             console.error('Error decoding token:', error);
//             return null;
//         }
//     };

//     const saveCartToDatabase = async (phoneNumber) => {
//         if (cartItems.length > 0) {
//             try {
//                 await axios.post("/api/cart", {
//                     userId: phoneNumber,
//                     items: cartItems,
//                 });
//                 console.log("Cart saved successfully!");
//             } catch (error) {
//                 console.error("Error saving cart:", error);
//                 alert("Could not save cart items. Please try again.");
//             }
//         }
//     };

//     // const handleLoginSuccess = async (token) => {
//     //     const decodedToken = decodeJWT(token);
//     //     if (decodedToken && decodedToken.phoneNumber) {
//     //         const phoneNumber = decodedToken.phoneNumber;
//     //         localStorage.setItem("token", token);
//     //         localStorage.setItem("phoneNumber", phoneNumber);

//     //         // Save cart to database
//     //         await saveCartToDatabase(phoneNumber);

//     //         const returnToCheckout = localStorage.getItem("returnToCheckout");
//     //         if (returnToCheckout === "true") {
//     //             localStorage.removeItem("returnToCheckout");
//     //             navigate("/checkout");
//     //         } else {
//     //             const from = location.state?.from || "/";
//     //             navigate(from);
//     //         }
//     //     } else {
//     //         console.error("Failed to extract phoneNumber from token");
//     //         setError("Login failed. Please try again.");
//     //     }
//     // };
//     const handleLoginSuccess = async (token) => {
//       const decodedToken = decodeJWT(token);
//       if (decodedToken && decodedToken.phoneNumber) {
//           const phoneNumber = decodedToken.phoneNumber;

//           // Save auth data
//           localStorage.setItem("token", token);
//           localStorage.setItem("phoneNumber", phoneNumber);

//           // Redirect after login
//           const from = location.state?.from || "/"; // Redirect to the original page or home
//           navigate(from); 
//       } else {
//           console.error("Failed to extract phoneNumber from token");
//           setError("Login failed. Please try again.");
//       }
//   };

//     const handleLoginSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setLoading(true);

//     try {
//       if (loginMode === "password") {
//         const response = await axios.post("/api/login", {
//           identifier,
//           password,
//         });

//         await handleLoginSuccess(response.data.token);
//       } else if (loginMode === "otp") {
//         if (!otpSent) {
//           const response = await axios.post("/api/send-otp", {
//             phoneNumber: identifier,
//           });
//           alert(response.data.message);
//           setOtpSent(true);
//         } else {
//           const response = await axios.post("/api/verify-otp-login", {
//             phoneNumber: identifier,
//             otp,
//           });

//           await handleLoginSuccess(response.data.token);
//         }
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || "Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("phoneNumber");
//     alert("You have logged out successfully.");
//     navigate("/login");
//   };

//   const isLoggedIn = localStorage.getItem("token");

//   return (
//     <div>
//       {isLoggedIn ? (
//         <div>
//           <h2>You are already logged in.</h2>
//           <button onClick={handleLogout}>Logout</button>
//         </div>
//       ) : (
//         <div>
//           <h2>{loginMode === "password" ? "Password Login" : "OTP Login"}</h2>
//           <form onSubmit={handleLoginSubmit}>
//             <div>
//               <input
//                 type="text"
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value)}
//                 placeholder={loginMode === "password" ? "Enter email or mobile" : "Enter mobile number"}
//                 required
//               />
//             </div>

//             {loginMode === "password" ? (
//               <div>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   required
//                 />
//               </div>
//             ) : (
//               otpSent && (
//                 <div>
//                   <input
//                     type="text"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     placeholder="Enter OTP"
//                     required
//                   />
//                 </div>
//               )
//             )}

//             {error && <p className="{ color: "red" }}>{error}</p>}

//             <button type="submit" disabled={loading}>
//               {loading
//                 ? "Loading..."
//                 : loginMode === "password"
//                 ? "Login"
//                 : otpSent
//                 ? "Verify OTP"
//                 : "Send OTP"}
//             </button>
//           </form>

//           <button onClick={() => setLoginMode(loginMode === "password" ? "otp" : "password")}>
//             {loginMode === "password" ? "Login with OTP" : "Login with Password"}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Login;




// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import jwtDecode from "jwt-decode";
// import { useCart } from "../../pages/CartContext/CartProvider";

// // Modal styles
// const modalOverlayStyle = {
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   backgroundColor: 'rgba(0, 0, 0, 0.5)',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   zIndex: 1000
// };

// const modalContentStyle = {
//   backgroundColor: 'white',
//   padding: '20px',
//   borderRadius: '8px',
//   maxWidth: '500px',
//   width: '90%',
//   maxHeight: '90vh',
//   overflowY: 'auto',
//   position: 'relative'
// };

// const closeButtonStyle = {
//   position: 'absolute',
//   right: '10px',
//   top: '10px',
//   background: 'none',
//   border: 'none',
//   fontSize: '20px',
//   cursor: 'pointer'
// };

// // Modal wrapper component
// const LoginModal = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="modalOverlayStyle} onClick={onClose}>
//       <div className="modalContentStyle} onClick={e => e.stopPropagation()}>
//         <button className="closeButtonStyle} onClick={onClose}>×</button>
//         <Login onSuccessfulLogin={onClose} />
//       </div>
//     </div>
//   );
// };

// // Original Login component with minimal modifications
// const Login = ({ onSuccessfulLogin }) => {
//     const [loginMode, setLoginMode] = useState("password");
//     const [identifier, setIdentifier] = useState("");
//     const [password, setPassword] = useState("");
//     const [otp, setOtp] = useState("");
//     const [otpSent, setOtpSent] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const { cartItems } = useCart();
//     const navigate = useNavigate();
//     const location = useLocation();

//     const decodeJWT = (token) => {
//         try {
//             const base64Url = token.split('.')[1];
//             const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//             const jsonPayload = decodeURIComponent(
//                 atob(base64)
//                     .split('') 
//                     .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//                     .join('')
//             );
//             return JSON.parse(jsonPayload);
//         } catch (error) {
//             console.error('Error decoding token:', error);
//             return null;
//         }
//     };

//     const saveCartToDatabase = async (phoneNumber) => {
//         if (cartItems.length > 0) {
//             try {
//                 await axios.post("/api/cart", {
//                     userId: phoneNumber,
//                     items: cartItems,
//                 });
//                 console.log("Cart saved successfully!");
//             } catch (error) {
//                 console.error("Error saving cart:", error);
//                 alert("Could not save cart items. Please try again.");
//             }
//         }
//     };

//     const handleLoginSuccess = async (token) => {
//       const decodedToken = decodeJWT(token);
//       if (decodedToken && decodedToken.phoneNumber) {
//           const phoneNumber = decodedToken.phoneNumber;

//           localStorage.setItem("token", token);
//           localStorage.setItem("phoneNumber", phoneNumber);

//           const from = location.state?.from || "/";
//           onSuccessfulLogin?.(); // Close the modal on successful login
//           navigate(from); 
//       } else {
//           console.error("Failed to extract phoneNumber from token");
//           setError("Login failed. Please try again.");
//       }
//     };

//     const handleLoginSubmit = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setLoading(true);

//         try {
//             if (loginMode === "password") {
//                 const response = await axios.post("/api/login", {
//                     identifier,
//                     password,
//                 });

//                 await handleLoginSuccess(response.data.token);
//             } else if (loginMode === "otp") {
//                 if (!otpSent) {
//                     const response = await axios.post("/api/send-otp", {
//                         phoneNumber: identifier,
//                     });
//                     alert(response.data.message);
//                     setOtpSent(true);
//                 } else {
//                     const response = await axios.post("/api/verify-otp-login", {
//                         phoneNumber: identifier,
//                         otp,
//                     });

//                     await handleLoginSuccess(response.data.token);
//                 }
//             }
//         } catch (error) {
//             setError(error.response?.data?.message || "Something went wrong.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleLogout = () => {
//         localStorage.removeItem("token");
//         localStorage.removeItem("phoneNumber");
//         alert("You have logged out successfully.");
//         navigate("/login");
//     };

//     const isLoggedIn = localStorage.getItem("token");

//     return (
//         <div className="p-6">
//             {isLoggedIn ? (
//                 <div className="space-y-4">
//                     <h2 className="text-xl font-semibold">You are already logged in.</h2>
//                     <button 
//                         onClick={handleLogout}
//                         className="w-full px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
//                         className="{
//                             backgroundColor: '#dc2626',
//                             padding: '0.5rem 1rem',
//                             borderRadius: '0.25rem',
//                             color: 'white',
//                             width: '100%'
//                         }}
//                     >
//                         Logout
//                     </button>
//                 </div>
//             ) : (
//                 <div className="space-y-6">
//                     <h2 className="text-xl font-semibold" className="{ fontSize: '1.25rem', fontWeight: 600 }}>
//                         {loginMode === "password" ? "Password Login" : "OTP Login"}
//                     </h2>
//                     <form onSubmit={handleLoginSubmit} className="space-y-4">
//                         <div>
//                             <input
//                                 type="text"
//                                 value={identifier}
//                                 onChange={(e) => setIdentifier(e.target.value)}
//                                 placeholder={loginMode === "password" ? "Enter email or mobile" : "Enter mobile number"}
//                                 required
//                                 className="{
//                                     width: '100%',
//                                     padding: '0.5rem 0.75rem',
//                                     border: '1px solid #d1d5db',
//                                     borderRadius: '0.25rem',
//                                     marginBottom: '1rem'
//                                 }}
//                             />
//                         </div>

//                         {loginMode === "password" ? (
//                             <div>
//                                 <input
//                                     type="password"
//                                     value={password}
//                                     onChange={(e) => setPassword(e.target.value)}
//                                     placeholder="Enter your password"
//                                     required
//                                     className="{
//                                         width: '100%',
//                                         padding: '0.5rem 0.75rem',
//                                         border: '1px solid #d1d5db',
//                                         borderRadius: '0.25rem',
//                                         marginBottom: '1rem'
//                                     }}
//                                 />
//                             </div>
//                         ) : (
//                             otpSent && (
//                                 <div>
//                                     <input
//                                         type="text"
//                                         value={otp}
//                                         onChange={(e) => setOtp(e.target.value)}
//                                         placeholder="Enter OTP"
//                                         required
//                                         className="{
//                                             width: '100%',
//                                             padding: '0.5rem 0.75rem',
//                                             border: '1px solid #d1d5db',
//                                             borderRadius: '0.25rem',
//                                             marginBottom: '1rem'
//                                         }}
//                                     />
//                                 </div>
//                             )
//                         )}

//                         {error && <p className="{ color: '#dc2626' }}>{error}</p>}

//                         <button 
//                             type="submit" 
//                             disabled={loading}
//                             className="{
//                                 width: '100%',
//                                 padding: '0.5rem 1rem',
//                                 backgroundColor: loading ? '#93c5fd' : '#2563eb',
//                                 color: 'white',
//                                 borderRadius: '0.25rem',
//                                 cursor: loading ? 'not-allowed' : 'pointer',
//                                 marginBottom: '1rem'
//                             }}
//                         >
//                             {loading
//                                 ? "Loading..."
//                                 : loginMode === "password"
//                                 ? "Login"
//                                 : otpSent
//                                 ? "Verify OTP"
//                                 : "Send OTP"}
//                         </button>
//                     </form>

//                     <button 
//                         onClick={() => setLoginMode(loginMode === "password" ? "otp" : "password")}
//                         className="{
//                             width: '100%',
//                             padding: '0.5rem 1rem',
//                             backgroundColor: 'white',
//                             color: '#2563eb',
//                             border: '1px solid #2563eb',
//                             borderRadius: '0.25rem',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         {loginMode === "password" ? "Login with OTP" : "Login with Password"}
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default LoginModal;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css"
import { useCart } from "../../pages/CartContext/CartProvider";

const LoginModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;



  return (
    <div className="modalOverlayStyle" onClick={onClose}>
      <div className="modalContentStyle" onClick={e => e.stopPropagation()}>
        <button className="closeButtonStyle" onClick={onClose}>×</button>
        <div className="formContainerStyle">
          <Login onSuccessfulLogin={onClose} />
        </div>
      </div>
    </div>
  );
};
const Login = ({ onSuccessfulLogin }) => {
  const [loginMode, setLoginMode] = useState("otp");
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpExpiresAt, setOtpExpiresAt] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  // Styles

  const decodeJWT = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  const saveCartToDatabase = async (phoneNumber) => {
    if (cartItems.length > 0) {
      try {
        await axios.post("/api/cart", {
          userId: phoneNumber,
          items: cartItems,
        });
        console.log("Cart saved successfully!");
      } catch (error) {
        console.error("Error saving cart:", error);
        alert("Could not save cart items. Please try again.");
      }
    }
  };
  //correctone
  const handleLoginSuccess = async (token) => {
    const decodedToken = decodeJWT(token);
    if (decodedToken && decodedToken.phoneNumber) {
      const phoneNumber = decodedToken.phoneNumber;
      const role = decodedToken.role;
      // Save auth data
      localStorage.setItem("token", token);
      localStorage.setItem("phoneNumber", phoneNumber);
      localStorage.setItem("role", role);

      // Save cart to database
      await saveCartToDatabase(phoneNumber);

      // Handle redirect logic
      const returnToCheckout = localStorage.getItem("returnToCheckout");
      if (returnToCheckout === "true") {
        localStorage.removeItem("returnToCheckout");
        navigate("/checkout");
      } else {
        const from = location.state?.from || "/";
        onSuccessfulLogin?.();
        navigate(from);
      }
    } else {
      console.error("Failed to extract phoneNumber from token");
      setError("Login failed. Please try again.");
    }
  };


  // const handleLoginSubmit = async (e) => {
  //   e.preventDefault();
  //   setError(null);
  //   setLoading(true);

  //   try {
  //     if (loginMode === "password") {
  //       const response = await axios.post("/api/login", {
  //         identifier,
  //         password,
  //       });
  //       await handleLoginSuccess(response.data.token);
  //     } else if (loginMode === "otp") {
  //       if (!otpSent) {
  //         const response = await axios.post("/api/send-otp", {
  //           phoneNumber: identifier,
  //         });
  //         alert(response.data.message);
  //         setOtpSent(true);
  //       } else {
  //         const response = await axios.post("/api/verify-otp", {
  //           phoneNumber: identifier,
  //           otp,
  //         });alert(response.data.message);

  //         await handleLoginSuccess(response.data.token);
  //       }
  //     }
  //   } catch (error) {
  //     setError(error.response?.data?.message || "Something went wrong.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      if (loginMode === "password") {
        const response = await axios.post("/api/login", {
          identifier,
          password,
        });
        await handleLoginSuccess(response.data.token);
      } else if (loginMode === "otp") {
        if (!otpSent) {
          await sendOTP();
        } else {
          const response = await axios.post("/api/verify-otp", {
            phoneNumber: identifier,
            otp,
          });
          await handleLoginSuccess(response.data.token);
        }
      }
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const sendOTP = async () => {
    try {
      const response = await axios.post("/api/send-otp", {
        phoneNumber: identifier,
      });
      alert(response.data.message);
      setOtpSent(true);

      // Set initial countdown to 5 minutes
      const expirationTime = Date.now() + 5 * 60 * 1000;
      setOtpExpiresAt(expirationTime);

      // Initialize countdown
      setCountdown(5 * 60);
      setCanResendOtp(false);
    } catch (error) {
      setError(error.response?.data?.message || "Failed to send OTP");
    }
  };

  const handleResendOTP = async () => {
    if (!canResendOtp) return;

    try {
      await sendOTP();
    } catch (error) {
      setError("Failed to resend OTP");
    }
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prevCountdown => {
          if (prevCountdown <= 1) {
            clearInterval(timer);
            setCanResendOtp(true);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);

  // Format countdown to MM:SS
  const formatCountdown = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };




  const isLoggedIn = localStorage.getItem("token");
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    alert("You have logged out successfully.");
    navigate("/login");
  };
  const clickHereStyle = {
    color: '#F59E0B',
    textDecoration: 'none',
    fontWeight: '500',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0
  };
  // const [otp, setOtp] = useState("");

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!isNaN(value) && value.length <= 1) {
      const newOtp = otp.split("");
      newOtp[index] = value;
      const updatedOtp = newOtp.join("");
      setOtp(updatedOtp);

      // Automatically focus next input
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };


  return (
    <div className="containerStyle">

      <div className="headerStyle">
        <img src="./Royalhoodlogo2.png" className="loginimg"/>
        <p className="titleStyle" >Sign In / Sign Up</p>
      </div>
      {isLoggedIn ? (
        <button
          onClick={handleLogout}
          className="buttonStyle"
        >
          Logout
        </button>
      ) : (

        <form onSubmit={handleLoginSubmit} className="formStyle">
          <div className="inputGroupStyle">
            {loginMode === "otp" && (
              <>
                <div>
                  {/* <label className="labelStyle">Mobile Number</label> */}
                  <input
                    type="tel"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    className="inputStyle"
                    placeholder="10-digit mobile number"
                    required

                  />
                </div>

                {/* {otpSent && (
                <div>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="inputStyle"
                    placeholder="Enter OTP"
                    required
                  />
                </div>
              )} */}

                {/* <div className="otp-input-container">
        {otpSent && [...Array(6)].map((_, index) => (
          <div>
          <input
            key={index}
            id={`otp-input-${index}`}
            type="text"
            value={otp[index] || ""}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            maxLength="1"
            className="otp-input"
          />
          <div className="linkTextStyle">
        <button
          type="button"
          onClick={handleResendOTP}
          style={{
            ...clickHereStyle,
            opacity: canResendOtp ? 1 : 0.5,
            cursor: canResendOtp ? 'pointer' : 'not-allowed'
          }}
          disabled={!canResendOtp}
        >
          {!canResendOtp 
            ? `Resend OTP in ${formatCountdown(countdown)}` 
            : "Resend OTP"}
        </button>
      </div>
      </div>
        ))}
      </div> */}
                 {otpSent && ( 
                  <div> 
                    <div className="otp-input-container">
                      {/* Render OTP input fields */}
                      {[...Array(6)].map((_, index) => (
                        <div key={index} className="otpinputs">
                          <input
                            id={`otp-input-${index}`}
                            type="text"
                            value={otp[index] || ""}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            maxLength="1"
                            className="otp-input"
                          />
                        </div>
                      ))}
                    </div>
                    {/* Render the resend OTP button once */}
                    <div className="linkTextStyle">
                      <button
                        type="button"
                        onClick={handleResendOTP}
                        style={{
                          ...clickHereStyle,
                          opacity: canResendOtp ? 1 : 0.5,
                          cursor: canResendOtp ? 'pointer' : 'not-allowed'
                        }}
                        disabled={!canResendOtp}
                      >
                        {!canResendOtp
                          ? `Resend OTP in ${formatCountdown(countdown)}`
                          : "Resend OTP"}
                      </button><br/><br/>
                      <b>Trouble getting OTP?</b><br/><br/>
<p>Make sure you entered correct mobile no./ email</p>
                    </div>
                  </div>
                )}

              </>
            )}



            {loginMode === "password" && (
              <>
                <div>
                  <input
                    type="text"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    className="inputStyle"
                    placeholder="Email or mobile number"
                    required
                  />
                </div>
                <div>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="inputStyle"
                    placeholder="Password"
                    required
                  />
                </div>
              </>
            )}
          </div>

          {error && <p className="errorStyle">{error}</p>}
          <p style={{position:"relative",width:"90%",marginLeft:"auto",marginRight:"auto",fontFamily:"MierB-Regular"}}>By Signing In, I agree to the Terms of Use and Privacy Policy </p>
          <button
            type="submit"
            disabled={loading}
            className="buttonStyle"
          >
            {loading
              ? "Please wait..."
              : loginMode === "password"
                ? "Login"
                : otpSent
                  ? "Verify OTP"
                  : "SEND OTP"}
          </button>

          {loginMode === "otp" && (
            <div className="linkTextStyle">
              Login using your email & password{" "}
              <button
                type="button"
                onClick={() => setLoginMode("password")}
                className="clickHereStyle"
              >
                Click here
              </button>
            </div>
          )}

          {loginMode === "password" && (
            <div className="linkTextStyle">
              <button
                type="button"
                onClick={() => setLoginMode("otp")}
                className="clickHereStyle"
              >
                Login with OTP instead
              </button>
            </div>
          )}
        </form>
      )
      }

    </div>
  );
};

export default LoginModal;


